var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Stack } from "@mui/material";
var IconCell = function (_a) {
    var Icon = _a.Icon, content = _a.content, iconSize = _a.iconSize, color = _a.color;
    var style = useMemo(function () { return ({
        color: color,
        ml: content ? 2 : 0,
        width: iconSize,
        height: iconSize,
    }); }, [content, iconSize]);
    if (!Icon) {
        return null;
    }
    return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", alignItems: "center" }, { children: [content, _jsx(Icon, { sx: style })] })));
};
export default React.memo(IconCell);
